/**
 * Idle/full timeouts for assessment item types, keyed by testlet.type. Applies regardless of
 * language -- same testlet.type + item.type should behave the same for English and Spanish
 * (ASSMNT-2005). Most of these testlet types (graphemePhonemeConversion, listeningComprehension,
 * pictureComprehension, writtenCommunication) only exist in Spanish content; vocabulary is the one
 * type genuinely shared with English (see EnglishVocabularyItemBuilder / SpanishVocabularyItemBuilder
 * in build_items.py, both producing testletType: "vocabulary" through the same frontend component).
 */
const ITEM_IDLE_TIMEOUTS_MS = {
  vocabulary: { idleEncouragementTimeout: 8000, idleSubmitTimeout: 20000 },
  graphemePhonemeConversion: { idleEncouragementTimeout: 8000, idleSubmitTimeout: 20000 },
  blending: { idleEncouragementTimeout: 8000, idleSubmitTimeout: 20000 },
  listeningComprehension: { idleEncouragementTimeout: 10000, idleSubmitTimeout: 25000 },
  pictureComprehension: { idleEncouragementTimeout: 10000, idleSubmitTimeout: 30000 },
  writtenCommunication: { idleEncouragementTimeout: 10000, idleSubmitTimeout: 30000 },
  formative: { idleEncouragementTimeout: 20000, idleSubmitTimeout: 60000 },
};

/**
 * Resolves the idle/full timeout pair for a testlet type, or null if there's no override
 * (caller should fall back to its own default). Keyed by testlet.type, not item.type, because
 * item.type collapses distinct testlet types to the same value (e.g. Spanish blending and
 * pictureComprehension are both 'mmc').
 */
export function getIdleTimeouts(testletType) {
  return ITEM_IDLE_TIMEOUTS_MS[testletType] || null;
}

/**
 * Resolves the pair for a story, or null.
 *
 * Prefer this over getIdleTimeouts(story.type) for anything a Formative suite can render.
 * AOS serves a Formative testlet under the task type its blueprint asks for, so on real data
 * story.type is never 'formative' and keying off it alone resolves the override in mock mode
 * only. Without the flag, a Formative testlet's bucketing and mmc items fall back to their
 * own component defaults, which differ, so the same idle child is auto-submitted at a
 * different moment depending on which item type they happen to be on.
 */
export function getIdleTimeoutsForStory(story) {
  if (story?.isFormative) return ITEM_IDLE_TIMEOUTS_MS.formative;
  return getIdleTimeouts(story?.type);
}
